import React, { useMemo, useState } from 'react';
import { SectionHeading } from '../ui/SectionHeading';
import { ButtonLink } from '../ui/ButtonLink';
import { ProjectCard } from '../projects/ProjectCard';
import { ProjectFilters } from '../projects/ProjectFilters';
import { projects } from '../../data/projects';
import { countByCategory, filterProjects, type CategoryFilter } from '../../utils/projects';
const ordered = [...projects.filter(p => p.featured), ...projects.filter(p => !p.featured)];
export function LatestProjects() {
  const [category, setCategory] = useState<CategoryFilter>('all');
  const counts = useMemo(() => countByCategory(projects), []);
  const visible = useMemo(() => filterProjects(ordered, category).slice(0, 6), [category]);
  const allLink = category === 'all' ? '/projects' : `/projects?category=${category}`;
  return <section aria-labelledby="projects-title" className="bg-charcoal-950 py-20 md:py-28" data-id="element-191" data-mp="1g2ug352caonm">
      <div className="mx-auto max-w-site px-5 md:px-8" data-id="element-192" data-mp="1l0w1hwn8n029">
        <div className="flex flex-col gap-8 md:flex-row md:items-end md:justify-between" data-id="element-193" data-mp="1p0kmi3fm4a7w">
          <SectionHeading id="projects-title" label="Portfolio" title="Our projects in action" intro="Explore selected infrastructure, construction and civil engineering projects documented in our company portfolio." className="max-w-2xl" data-id="element-194" data-mp="1k21247go36hn" />
          <ButtonLink to={allLink} variant="outline" showArrow className="self-start md:self-auto" data-id="element-195" data-mp="16avykua6hu21">
            View All Projects
          </ButtonLink>
        </div>

        <div className="mt-10" data-id="element-196" data-mp="11dmc9ni35yif">
          <ProjectFilters active={category} counts={counts} onChange={setCategory} data-id="element-197" data-mp="wbn8wdmcj1lh" />
        </div>

        <ul className="mt-8 grid gap-6 md:grid-cols-2 lg:grid-cols-3" aria-live="polite" data-id="element-198" data-mp="rdlnhm1g6q6u">
          {visible.map(project => <li key={project.id} data-id="element-199" data-mp="2qown2ipu7ba2">
              <ProjectCard project={project} data-id="element-200" data-mp="2qntvs9olr6tm" />
            </li>)}
        </ul>
      </div>
    </section>;
}